


































import { Component, Vue } from "vue-property-decorator";
import ExplorerButton from "@/components/ExplorerButton.vue";
import DropdownList from "@/components/DropdownList.vue";
import { dictionary } from "@/styles/dictionary";

@Component({
  components: {
    DropdownList,
    ExplorerButton
  }
})
export default class Home extends Vue {
  private title = dictionary.home.title;
  private introduction = dictionary.home.introduction;
  private categoriesTitle = dictionary.home.categoriesTitle;
  private categoriesDescription = dictionary.home.categoriesDescription;
  private keywordsTitle = dictionary.home.keywordsTitle;
  private keywordsDescription = dictionary.home.keywordsDescription;
}
